/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: external-system-logging-component
 *
 * Created by rwilliams on 10/5/17.
 */
'use strict';

function ExternalMetadataSystemLoggingController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $timeout: JS5Function,
    uiGridConstants: JS5Object,
    ExternalMetadataService: JS5Object,
    NavbarUtilService: JS5Object,
    PaginationService: JS5Object,
    SearchFilterService: JS5Object
) {
	const gridColumns = [
		{
			field: 'externalSystem',
			displayName: 'External System',
			sort: {
				direction: uiGridConstants.ASC,
				priority: 0
			},
			cellTemplate: 'components/visual/grid/base-tooltip-template.html'
		},
		{
			field: 'externalId',
			displayName: 'External ID',
			cellTemplate: 'components/visual/grid/base-tooltip-template.html'
		},
		{
			field: 'packageName',
			displayName: 'Package Name',
			cellTemplate: 'components/visual/grid/base-tooltip-template.html',
			width: 300
		},
		{
			field: 'packageId',
			displayName: 'Package Id',
			cellTemplate: 'system/externalMetadata/logging/external-metadata-package-link-cell-template.html'
		},
		{
			field: 'date',
			displayName: 'Date',
			cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"'
		},
		{
			field: 'source',
			displayName: 'Source',
			cellTemplate: 'components/visual/grid/base-tooltip-template.html'
		},
		{
			field: 'type',
			displayName: 'Type',
			cellTemplate: 'components/visual/grid/base-tooltip-template.html'
		},
		{
			field: 'body',
			displayName: 'Body',
			cellTemplate: 'components/visual/grid/base-tooltip-template.html'
		}
	];

	let getData = (): void => {
		let criteria = {
			fetchOffset: this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1),
			fetchLimit: this.pagingOptions.pageSize,
			searchString: $location.search().searchText || null
		};
		this.loadingIndicator.show = true;
		ExternalMetadataService.getExternalMetadataLogging(criteria, handleGridDataQuery).then((data: JS5Object): void => {
			this.gridOptions.data = data;
			this.loadingIndicator.show = false;
		});
	};

	function onPaginationChanged(): void {
		getData();
	}

	function handleGridDataQuery(gridData: JS5Object, responseHeaders: JS5Function) {
		PaginationService.parseResponseHeaders(responseHeaders());
		PaginationService.pageData = gridData;
	}

	this.gridOptions = {
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: false,
		enableColumnResizing: true,
		enablePaginationControls: false,
		enableSorting: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		enableHorizontalScrollbar: uiGridConstants.ALWAYS,
		enableVerticalScrollbar: uiGridConstants.ALWAYS,
		rowHeight: 26,
		multiSelect: false,
		columnDefs: gridColumns,
		onRegisterApi: (gridApi: JS5Object): void => {
			this.gridApi = gridApi;
		},
		rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
		data: []
	};

	this.executeSearch = (): void => {
		this.gridApi.grid.refresh();
	};

	// Should be able to replace this with a template variable in Angular 2
    // If not, then use @Input with an observable
	this.onPackageIdClicked = (packageId: string): void => {
	    $timeout(() => {
	        document.getElementById(`packageLinkIcon${packageId}`).click();
        });
    };

	this.onPackageNavigationStarted = (): void => {
	    this.loadingIndicator.show = true;
    };

    this.onPackageNavigationEnded = (): void => {
        this.loadingIndicator.show = false;
    };

	this.paginationPageSizeChanged = function () {
		this.pagingOptions.currentPage = 1;
		onPaginationChanged();
	};

	this.paginationPrevPageHandler = function () {
		--this.pagingOptions.currentPage;
		onPaginationChanged();
	};

	this.paginationNextPageHandler = function () {
		++this.pagingOptions.currentPage;
		onPaginationChanged();
	};

	this.paginationDefs = {
		paginationPrevPageHandler: this.paginationPrevPageHandler,
		paginationNextPageHandler: this.paginationNextPageHandler,
		paginationPageSizeChanged: this.paginationPageSizeChanged,
		paginationJumpToPageHandler: onPaginationChanged,
		pagingOptions: PaginationService,
        pageNumberIsTextInput: true,
	};

	this.$onInit = (): void => {
		this.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		this.pagingOptions = PaginationService;
		NavbarUtilService.viewSearchFunction = getData;
		SearchFilterService.populateCriteriaFromLocationSearch();

		getData();
	};

	this.$onDestroy = (): void => {
		NavbarUtilService.viewSearchFunction = null;
	};
}

angular.module('prism-ui.externalMetadata').component('externalMetadataSystemLogging', {
	controller: ExternalMetadataSystemLoggingController,
	templateUrl: 'system/externalMetadata/logging/external-metadata-system-logging-template.html'
});
